/*@flow*/
import type { KeyedCollection } from 'immutable';
import { connect } from 'react-redux';
import remap from 'lib/remap';
import store from 'store';
import React, { type AbstractComponent } from 'react';
// import type { Store } from 'redux';

type StateT = { [key: string]: KeyedCollection<*, *> };
// type ActionT = { type: string, payload: Object };
// type StoreT = Store<StateT, ActionT>;

type MapperT<Base, V = *> = { [key: string]: string | ((Base) => V) };
type CHOC<A, B> = (AbstractComponent<A>) => AbstractComponent<B>;

const connectWith = (mapper, Component) => {
  const mapStateToProps = (state: StateT, ownProps: any): any => {
    const m = remap(mapper || {}, { ownProps });
    return m(state);
  };
  return connect(mapStateToProps)(Component);
};

type K<Base, Enhanced> = CHOC<
  $Exact<Base>,
  $Diff<$Exact<Enhanced>, { store: any, __SKIP_CONNECTION__?: boolean }>
>;

// con creates a DSL for react-redux's connect function to map state to
// props, and wrap dispatch around action creators.
export default function con<Base: {}, Enhanced: {}>(
  mapper: MapperT<Base>
): K<Base, Enhanced> {
  return (Component) => {
    const ConnectedComponent = connectWith(mapper, Component);
    return (props) => {
      // In test mode, skip connection to store.
      // $FlowFixMe[prop-missing]
      if (props.__SKIP_CONNECTION__) {
        return <Component {...props} />;
      }
      return <ConnectedComponent store={store} {...props} />;
    };
  };
}
